<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :showSource="false" granularity="day" @on-selected="onPanelSelect">
        <template slot="leftSide">
          <hierarchy-menu @on-selected="onSelectedDevice"></hierarchy-menu>
        </template>
      </graph-tool-bar>
      <br />
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.reactive_energy}} {{$lang.tooltip.quadrant}} 2</h4>
        </md-card-header>
        <md-card-content>
          <highcharts class="charts" :options="chartOptions2" ref="pieChart_Q2"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.reactive_energy}} {{$lang.tooltip.quadrant}} 1</h4>
        </md-card-header>
        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="pieChart_Q1"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.reactive_energy}} {{$lang.tooltip.quadrant}} 3</h4>
        </md-card-header>
        <md-card-content>
          <highcharts class="charts" :options="chartOptions3" ref="pieChart_Q3"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.reactive_energy}} {{$lang.tooltip.quadrant}} 4</h4>
        </md-card-header>
        <md-card-content>
          <highcharts class="charts" :options="chartOptions4" ref="pieChart_Q4"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import HierarchyMenu from "./components/HierarchyMenu";
import graphToolBar from "@/components/GraphToolBar";
import { loadData } from "./components/functions.js";

import snackBar from "@/components/SnackBar";
import pieChartOptions from "@/config/charts/pie";

export default {
  components: {
    HierarchyMenu,
    "snack-bar": snackBar,
    graphToolBar
  },

  data() {
    return {
      chartOptions: null,
      chartOptions2: null,
      chartOptions3: null,
      chartOptions4: null,
      dateRange: {},
      devicesGroup: {}
    };
  },

  created() {
    this.chartOptions = JSON.parse(JSON.stringify(pieChartOptions));
    this.chartOptions.tooltip.pointFormat = "<b>{point.y:.1f} kVArh</b> ({point.percentage:.1f}%)";
    this.chartOptions.plotOptions.pie.dataLabels.format = "<b>{point.name}</b>: {point.y:.1f} kVArh ({point.percentage:.1f}%)";

    this.chartOptions2 = JSON.parse(JSON.stringify(this.chartOptions));
    this.chartOptions3 = JSON.parse(JSON.stringify(this.chartOptions));
    this.chartOptions4 = JSON.parse(JSON.stringify(this.chartOptions));

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.chartOptions2.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.chartOptions3.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.chartOptions4.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    async onPanelSelect(data) {
      this.dateRange = data.date;
      if (Object.keys(this.devicesGroup).length > 0) {
        this.$store.commit("setLoading", true);
        loadData(this.devicesGroup, this.$refs["pieChart_Q1"], this.dateRange, "Q1", this.$lang.charts.other);
        loadData(this.devicesGroup, this.$refs["pieChart_Q2"], this.dateRange, "Q2", this.$lang.charts.other);
        loadData(this.devicesGroup, this.$refs["pieChart_Q3"], this.dateRange, "Q3", this.$lang.charts.other);
        await loadData(this.devicesGroup, this.$refs["pieChart_Q4"], this.dateRange, "Q4", this.$lang.charts.other);
        this.$store.commit("setLoading", false);
      }
    },

    async onSelectedDevice(devices) {
      this.devicesGroup = devices;
      if (Object.keys(this.dateRange).length > 0) {
        this.$store.commit("setLoading", true);
        loadData(this.devicesGroup, this.$refs["pieChart_Q1"], this.dateRange, "Q1", this.$lang.charts.other);
        loadData(this.devicesGroup, this.$refs["pieChart_Q2"], this.dateRange, "Q2", this.$lang.charts.other);
        loadData(this.devicesGroup, this.$refs["pieChart_Q3"], this.dateRange, "Q3", this.$lang.charts.other);
        await loadData(this.devicesGroup, this.$refs["pieChart_Q4"], this.dateRange, "Q4", this.$lang.charts.other);
        this.$store.commit("setLoading", false);
      }
    }

  }
};
</script>

<style scoped>
</style>